import { get } from "lodash"
import { getPortfolioId, getSelectedModelId } from "modules/portfolio-root/selectors/portfolios"
import { getSelectedExperiment } from "./selectors"
import { getCurrentConstraints } from "./selectors/constraints"

function getPreferenceKeyType(state, constraintsType) {
  const selectedExperiment = getSelectedExperiment(state)
  if (selectedExperiment) {
    return null
  }

  const portfolioUUID = getPortfolioId(state)

  if (constraintsType === "exposure") {
    const modelId = getSelectedModelId(state)
    return { type: "optimizationExposures", key: `${portfolioUUID}:${modelId}` }
  }

  return { type: "optimizationConstraints", key: portfolioUUID }
}

export function resetPreferencesItems(state) {
  const selectedExperiment = getSelectedExperiment(state)
  if (selectedExperiment) {
    return null
  }

  const portfolioId = getPortfolioId(state)
  const modelId = getSelectedModelId(state)
  return [
    { type: "optimizationExposures", key: `${portfolioId}:${modelId}` },
    { type: "optimizationForecast", key: `${portfolioId}` },
    { type: "optimizationConstraints", key: `${portfolioId}` },
  ]
}

export function getForecastPreferencesItems(state) {
  const selectedExperiment = getSelectedExperiment(state)
  if (selectedExperiment) {
    return null
  }

  return [{
    type: "optimizationForecast",
    key: getPortfolioId(state),
    value: get(getCurrentConstraints(state), "settings"),
  }]
}

export function getConstraintsPreferencesItems(state, constraintsType) {
  const selectedExperiment = getSelectedExperiment(state)

  if (selectedExperiment) {
    return null
  }

  return [{
    ...getPreferenceKeyType(state, constraintsType),
    value: get(getCurrentConstraints(state), constraintsType),
  }]
}

export function getExposurePreferencesItems(state) {
  return getConstraintsPreferencesItems(state, "exposure")
}
